import { ethers } from "ethers";

export async function fetchEVMBalance(address: string, rpcUrl: string) {
    if (!ethers.utils.isAddress(address)) {
        return "Invalid Ethereum address";
    }

    try {
        const provider = new ethers.providers.JsonRpcProvider(rpcUrl);
        const balanceWei = await provider.getBalance(address);
        const balanceEth = ethers.utils.formatEther(balanceWei);
        console.log("balanceEth", balanceEth);

        return Number(balanceEth);
    } catch (err) {
        return 0;
    }
}